require([
	// Application.
	'backbone',
	'underscore',
	'app',
	'jquery-private',

	// Main Router.
	'router',

	// Application Modules.
	'modules/carousel/carousel',
	'modules/ptera/ptera-responsive-image',
	'modules/filter/filter',
	'modules/modal/modal',
	'modules/header/navigation'

	// Vendors


],

function(Backbone, _, app, $, Router, Carousel, PteraResponsiveImage, Filter, Modal, navigation) {

	app.router = new Router();

	var carousel = new Carousel();
	var responsiveImages = new PteraResponsiveImage();
	var filter = new Filter();
	

	var detectIEVersion = function () {
	    if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) { //test for MSIE x.x;
	        var ieversion = new Number(RegExp.$1) // capture x.x portion and store as a number
	        return ieversion;
	    } else {
	        return -1;
	    }
	}

	var detection = detectIEVersion();

	var headerNavigation = new navigation();

	$(document).ready(function () {
		document.modal = new Modal();
		// this needs the dom to be ready ;/
		// one time use
		// var gradeHEaders = new PteraCheckboxHeaders();

		// Kill drupal scrolltop on ajax, it's shit
		if (typeof Drupal != 'undefined' && Drupal.ajax) {
			Drupal.ajax.prototype.commands.viewsScrollTop = null;
		}

		Drupal.behaviors.wced_catalogue = {
    attach: function (context, settings) {
      $('.views-field-name', context).click(function() {
        $(this).parent().addClass('active-grades').siblings().removeClass('active-grades');

        var phasetid = jQuery(this).attr('data');
        jQuery.each(Drupal.views.instances, function(i, view) {
          console.log(view);
          var selector = ".js-view-dom-id-" + view.settings.view_dom_id;
          if (view.settings.view_name === "teacher_selection" && view.settings.view_display_id === "block_2" ) {
            console.log(view.settings.view_dom_id);
            view.settings.view_args = 67166;
            jQuery(selector).triggerHandler("RefreshView");
            triggerSubmenu();
            triggerSelect();
          }
          jQuery(selector).unbind();
        });

      });

 			$("[href^='#']").click(function() {
        $("html, body").animate({ scrollTop: document.body.scrollHeight }, 'slow');
    	});

    }
  };

		//  IE really doesn't want to resize, so running a 5 second interval instead
		if (app.IEVersion == 8) {
				// var carouselInterval = setInterval(function(){
				carousel.removeListeners(true);
				carousel.toggleDisplay();
		}
	});

	// Router is not working in IE8, I actually don't care anymore
	Backbone.history.start({pushState: "pushState" in window.history});
});


define("main", function(){});

